import React from "react";
import { Link } from "react-router-dom";

const CourseCard = ({ admissionNumber, courseName, intake, feeBalance }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
    }).format(amount);
  };

  const getBalanceColor = (balance) => {
    if (balance === 0) return 'text-green-600 bg-green-50';
    if (balance > 0) return 'text-red-600 bg-red-50';
    return 'text-gray-600 bg-gray-50';
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      {/* Header with Course Icon */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center mr-3">
            <span className="text-white text-lg font-bold">
              {courseName.charAt(0)}
            </span>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900 leading-tight">
              {courseName}
            </h2>
            <p className="text-sm text-gray-500">Course Program</p>
          </div>
        </div>
      </div>

      {/* Course Details */}
      <div className="space-y-3 mb-6">
        <div className="flex items-center">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
            <span className="text-blue-600 text-sm">🎓</span>
          </div>
          <div>
            <p className="text-xs text-gray-500">Admission Number</p>
            <p className="font-semibold text-gray-900">{admissionNumber}</p>
          </div>
        </div>

        <div className="flex items-center">
          <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
            <span className="text-green-600 text-sm">📅</span>
          </div>
          <div>
            <p className="text-xs text-gray-500">Intake Period</p>
            <p className="font-semibold text-gray-900">{intake}</p>
          </div>
        </div>

        <div className="flex items-center">
          <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
            <span className="text-orange-600 text-sm">💰</span>
          </div>
          <div className="flex-1">
            <p className="text-xs text-gray-500">Fee Balance</p>
            <div className="flex items-center justify-between">
              <p className="font-bold text-gray-900">{formatCurrency(feeBalance)}</p>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getBalanceColor(feeBalance)}`}>
                {feeBalance === 0 ? 'Paid' : feeBalance > 0 ? 'Outstanding' : 'Credit'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="border-t border-gray-100 pt-4">
        <div className="flex gap-2">
          <Link 
            to="/change-course" 
            className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-medium py-2.5 px-4 rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 text-center shadow-md hover:shadow-lg"
          >
            Change Course
          </Link>
          <Link 
            to="/defer" 
            className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm font-medium py-2.5 px-4 rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all duration-200 text-center shadow-md hover:shadow-lg"
          >
            Defer Course
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
